import { render, staticRenderFns } from "./InboxLine.vue?vue&type=template&id=649b836e&scoped=true&"
import script from "./InboxLine.vue?vue&type=script&lang=ts&"
export * from "./InboxLine.vue?vue&type=script&lang=ts&"
import style0 from "./InboxLine.vue?vue&type=style&index=0&id=649b836e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649b836e",
  null
  
)

export default component.exports